<template>
  <font-awesome-icon
    :icon="{ prefix: 'fab', iconName: 'youtube' }" />
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'

library.add(faYoutube)

export default {
  name: 'CoozzyYoutubeIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-yellow;
  }
</style>
